import Vue from 'vue';
import ElementUI from 'element-ui';
import TokenShared from '@/token-shared'; // permission control
import QRCode from 'qrcodejs2';

/**
 * Created by PanJiaChen on 16/11/18.
 */
import dataOpration from './data-opration';
import { scrollTo } from './scroll-to';

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ');
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split('&');
  searchArr.forEach(v => {
    const index = v.indexOf('=');
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

export function validateNumWithPoint(rule, value, callback) {
  console.log(value);
  console.log(!/^\d+(\.?\d{1,2})?$/.test(value));
  if (!/^\d+(\.?\d{1,2})?$/.test(value)) {
    return callback(new Error('请填写数字'));
  } else {
    callback();
  }
}

export function validateChar(len) {
  var validateCH = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入商品名称'));
    }
    var StringCharLen = 0; // 字符串字符长度
    for (var i = 0; i < value.length; i++) {
      var a = value.charAt(i);
      if (a.match(/[^\x00-\xff]/gi) != null) {
        StringCharLen += 2;
      } else {
        StringCharLen += 1;
      }
    }
    if (StringCharLen > len) {
      return callback(new Error(`限${len}个字符`));
    } else {
      callback();
    }
  };
  return validateCH;
}

export function validateNum(rule, value, callback) {
  if (!/^\d+$/.test(value)) {
    callback(new Error('请填写正整数'));
  } else {
    callback();
  }
}

export function genId() {
  return +new Date();
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

function getUUID(length = 8) {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0;
      var v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
    .substr(0, length);
}

export default {
  // 获取第一个错误信息
  getFirstValidErrMsg(err) {
    const keys = Object.keys(err);
    const firstKey = keys[0];
    // 获取路径信息 补充
    let idxMsg = '';
    const mat = firstKey.match(/^.*(\d+).*$/);
    if (mat) {
      idxMsg = `第${+mat[1] + 1}项: `;
    }

    return keys.length ? `${idxMsg}${err[firstKey][0].message}` : '';
  },
  genId() {
    return (
      S4() +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      S4() +
      S4()
    );
  },
  isFrontId(id) {
    return id.length === 36;
  },
  genNumId() {
    return parseInt(Math.random() * 100000000000);
  },
  getCurLinkByItem(item) {
    if (!item) return;
    if (item.linkType === 'system') {
      return item.systemLink;
    } else if (item.linkType === 'custom') {
      if (item.customType === 'h5') {
        return item.h5Link;
      } else if (item.customType === 'mini') {
        return item.miniLink;
      } else if (item.customType === 'otherMini') {
        const key =
          item.otherType === 'alipay' ? 'otherMiniAlipayLink' : 'otherMiniLink';
        return item[key]?.appId && item[key]?.path;
      }
    }
  },
  checkSystemLink(val) {
    if (val.linkType === 'custom' && val.customType === 'otherMini') {
      const key =
        val.otherType === 'alipay' ? 'otherMiniAlipayLink' : 'otherMiniLink';
      if (!!val[key].appId.trim() + !!val[key].path.trim() !== 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  },
  // 为了重写duration
  overrideMessage: () => {
    const _conbineArg = arg => {
      let options = {};
      if (typeof arg === 'string') {
        options = {
          message: arg,
          duration: 1.5 * 1000,
        };
      } else {
        options = {
          ...arg,
          duration: 1.5 * 1000,
        };
      }
      return options;
    };

    Vue.prototype.$message = function(arg) {
      ElementUI.Message(_conbineArg(arg));
    };

    Vue.prototype.$message = new Proxy(Vue.prototype.$message, {
      get(target, key) {
        const fn = Reflect.get(ElementUI.Message, key);
        return arg => {
          fn(_conbineArg(arg));
        };
      },
    });
  },
  getTokenSharedUrl: TokenShared.getUrl,
  // 合并其他模块,并去掉命名空间,方便使用
  ...dataOpration,
  scrollTo,
  sleep: (t = 0) => new Promise(r => setTimeout(() => r(), t)),
  pickerOptionsNormal: {
    shortcuts: [
      {
        text: '最近一周',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        },
      },
    ],
  },
  getDisableYestoday(nowTime = new Date()) {
    return time => {
      return time.getTime() < nowTime - 8.64e7;
    };
  },
  getImgWidthHeight(url, callback) {
    var img = new Image();
    img.src = url;
    if (img.complete) {
      callback(img.width, img.height);
    } else {
      img.onload = function() {
        callback(img.width, img.height);
        img.onload = null;
      };
    }
  },
  getQrCodeImgSrc: url => {
    url = TokenShared.getUrl({
      href: location.origin + '/shop-decoration/shop-list/prev-picture',
    });

    // this.$router.push({ name: 'prev-picture' })
    const id = 'qrCodeXX';
    $('body').append(` <div
            id="${id}"
            style="display:none"
            title="false"
          ></div>`);
    new QRCode(id, {
      text: url,
      width: 260,
      height: 260,
      colorDark: '#333333', // 二维码颜色
      colorLight: '#ffffff', // 二维码背景色
      correctLevel: QRCode.CorrectLevel.M, // 容错率，L/M/H
    });
    var canvas = document.getElementsByTagName('canvas')[0];
    var img = convertCanvasToImage(canvas);
    function convertCanvasToImage(canvas) {
      // 新建Image对象
      var image = new Image(); // canvas.toDataURL 返回的是一串Base64编码的URL
      image.src = canvas.toDataURL('image/png');
      return image;
    }
    $(`#${id}`).remove();
    return img.src;
  },
  getUUID,
  swapArray: (arr, index1, index2) => {
    arr = _.cloneDeep(arr);
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  },
};

export const serialize = data => {
  const arr = [];
  for (const name in data) {
    arr.push(name + '=' + data[name]);
  }
  return arr.join('&');
};
